import { COMPARE_PERIODS } from "../../components/mb-compare-period/constants";
import DatePickerService from "../../services/datePickerService";
const datePickerService = new DatePickerService();

export const TopSkusChosenPeriodToDateConfig = (chosenPeriod, maxMoment) => {
  var rolling = 0;
  var dates;
  
  // Fix: If maxMoment is already Sunday, use it; otherwise get previous Sunday
  var lastSunday = maxMoment.isoWeekday() === 7
    ? maxMoment.clone()
    : maxMoment.clone().startOf("isoWeek").subtract(1, "days");

  switch (chosenPeriod) {
    // Day-based (SKU Tracker)
    case "Last 30 days":
      dates = datePickerService.onClickLastXDays(30, maxMoment);
      rolling = 7;
      break;
    case "Last 7 days":
      dates = datePickerService.onClickLastXDays(7, maxMoment);
      rolling = 5;
      break;
    case "Last day":
      dates = datePickerService.onClickLastXDays(1, maxMoment);
      rolling = 4;
      break;
    // Week-based (Brand Performance)
    case "Last week":
      dates = datePickerService.onClickLastXWeeks(1, lastSunday);
      rolling = 1;
      break;
    case "Last 2 weeks":
      dates = datePickerService.onClickLastXWeeks(2, lastSunday);
      rolling = 11;
      break;
    case "Last 4 weeks":
      dates = datePickerService.onClickLastXWeeks(4, lastSunday);
      rolling = 2;
      break;
    case "Last 13 weeks":
      dates = datePickerService.onClickLastXWeeks(13, lastSunday);
      rolling = 3;
      break;
    case "Year to date":
      dates = datePickerService.onClickYTD(lastSunday, "weekly");
      rolling = 10;
      break;
  }
  return {
    rolling,
    comparePeriod: COMPARE_PERIODS.previousPeriod,
    ...dates,
  };
};
